import $ from 'jquery';


class homeSlider{
    constructor(){

        this.slideDuration = 5000;
        this.fadeDuration = 3000;
        this.curIndex = 0;
        this.nextIndex = 0;
        this.imageCount = 0;
        this.sliderInterval = null;
        this.images = [{
            'src':'images/slider/twinwomb.jpg',
            //'src':'./php/showPictures/?c=Ny9sb3dyZXMvRFNDXzAyMTVlZGl0Mi13ZWIucG5n&cc=460474791',
            'title':'NEWBORNS',
            'subtitle':'Shutterbabee specializes on newborn photography'
        },{
            'src':'images/slider/teddy.jpg',
            // 'src':'images/slider/slider2-2.jpg',
            // 'src':'./php/showPictures/?c=Ny9sb3dyZXMvRFNDXzAyMjUtZWRpdDEtd2ViLnBuZw,,&cc=997882993',
            'title':'INNOCENCE',
            'subtitle':'Preserve the innocence forever'
        },{
            'src':'images/slider/liz.jpg',
            // 'src':'./php/showPictures/?c=Ny9sb3dyZXMvRFNDXzAyMzUtZWRpdDItd2ViLnBuZw,,&cc=897906727',
            'title':'BABIES',
            'subtitle':'Shutterbabee. Babies are cute'
        },{
            'src':'images/slider/aslider1.jpg',
            // 'src':'./php/showPictures/?c=Ny9sb3dyZXMvRFNDXzAyMzUtZWRpdDItd2ViLnBuZw,,&cc=897906727',
            'title':'BABIES',
            'subtitle':'Shutterbabee. Babies are cute'
        },{
            'src':'images/slider/slider10.jpg',
            // 'src':'./php/showPictures/?c=Ny9sb3dyZXMvRFNDXzAyMzUtZWRpdDItd2ViLnBuZw,,&cc=897906727',
            'title':'BABIES',
            'subtitle':'Shutterbabee. Babies are cute'
        }];
        // },{
        //     'src':'images/slider/web5.png',
        //     'title':'SOMETING',
        //     'subtitle':'Something here'
        // }];


        this.initOnReady();
    }
    initOnReady(){
        $(document).ready(()=>{
            this.initSlider();
        });
    }
    initSlider(){
        this.setSliderHeight();
        this.preloadImages();
    }
    setSliderHeight(){
        var pageHeight = $(window).height();
        var headerHeight = $('header').height();
        var sliderHeight = pageHeight - headerHeight;
        $('.homeSlider').css({
            //'max-height':sliderHeight + 'px',
            'height':sliderHeight+'px'
        });
    }
    setTextPosition(){
        let textWrapHeight = $('.textWrap').height();
        $('.textWrap').css({
            'margin-top': '-' + (textWrapHeight/2) + 'px'
        });
    }
    preloadImages(){
        this.images.forEach((img,index)=>{
            let t = new Image();
            t.onload = this.checkImageLoad.bind(this);
            t.src = img.src;
        });
    }
    checkImageLoad(){
        let imageLength = this.images.length;
        this.imageCount++;
        if(this.imageCount === imageLength){
            $('.homeSlider img.loading').remove();
            this.startSlider();
        }
    }
    startSlider(){
        this.startSliderSpin(this.curIndex);
        this.addNavButtons();
        this.addNavButtonEvents();
        this.addResizeEvents();
    }

    addNavButtons(){
        let navWrap = document.createElement('ul');
        navWrap.className='navWrap';

        for(let x=0;x<this.images.length;x++){
            let tt = document.createElement('li');
            tt.className = 'dot';
            tt.id = 'idx_' + x;
            $(navWrap).append(tt);
        }

        $('.homeSlider').append(navWrap);

        // adjust nav dot position
        let navWrapWidth = $(navWrap).width() / 2;
        $(navWrap).css({
            'margin-left' : '-' + navWrapWidth + 'px'
        });
    }
    addNavButtonEvents(){
        $('.navWrap .dot').click((e)=>{
            let idx = e.target.id.split('_')[1];
            this.curIndex = idx;

            this.stopSliderSpin();
            this.startSliderSpin(idx);
        });
    }

    addResizeEvents(){
        $(window).resize(()=>{
            this.setSliderHeight();
            this.setTextPosition();
        });
    }

    startSliderSpin(index){
        let instance = this;
        this.loadImage(index); // load first image

        // then start slider interval to load next images.
        this.sliderInterval = setInterval(function(){
            instance.loadImage(instance.getNextIndex());
        },this.slideDuration);
    }
    stopSliderSpin(){
        clearInterval(this.sliderInterval);
        this.sliderInterval = null;
    }

    loadImage(index){
        var instance = this;

        let sliderWrap = document.createElement('div');
        sliderWrap.className = 'sliderWrap animateSlow opac0';
        $('.homeSlider').append(sliderWrap);

        /* image wrap only */
        let bgWrap = document.createElement('div');
        bgWrap.className = 'bgWrap animateSuperSlow';
        $(sliderWrap).append(bgWrap);

        let bg = document.createElement('div');
        bg.style.backgroundImage='url('+this.images[index].src+')';
        bg.className = 'bg';
        $(bgWrap).append(bg);

        let cover = document.createElement('div');
        cover.className='cover';
        $(sliderWrap).append(cover);

        let textWrap = document.createElement('div');
        textWrap.className = 'textWrap';
        $(sliderWrap).append(textWrap);

        let title = document.createElement('div');
        title.className = 'title';
        title.innerHTML = this.images[index].title;
        $(textWrap).append(title);

        let bee = document.createElement('img');
        bee.src = 'images/beealone.png';
        bee.className = 'bee';
        $(textWrap).append(bee);

        let subtitle = document.createElement('div');
        subtitle.className = 'subtitle';
        subtitle.innerHTML = this.images[index].subtitle;
        $(textWrap).append(subtitle);

        (function(sliderWrap,bgWrap){
            setTimeout(()=>{
                instance.setTextPosition();

                $(sliderWrap).removeClass('opac0');
                setTimeout(()=>{ bgWrap.style.transform = "scale(1.4, 1.4)"; },1); // for scale animation



                setTimeout(()=>{
                    $(sliderWrap).addClass('remover');
                    //instance.loadImage(instance.getNextIndex());
                    //setTimeout(()=>{
                    //    $(sliderWrap).remove();
                    //},instance.fadeDuration);
                },instance.slideDuration);


                // here also adjust navWrap
                $('.navWrap .dot').removeClass('active');
                $('.navWrap #idx_'+index).addClass('active');

            },0);
        })(sliderWrap,bgWrap);

        // remove all removers
        // * note:  since the above functions are in set timeout... this remover executes first.. this results in the very last remover staying in the DOM for this cycle for transition effects to take place correctly
        $('.homeSlider .remover').remove();
    }

    getNextIndex(){
        if(this.curIndex < this.images.length-1){
            this.curIndex++;
        }else{
            this.curIndex=0;
        }
        return this.curIndex;
    }
    appendImage(obj){

    }
}

export default new homeSlider();



// WEBPACK FOOTER //
// ./homeSlider.js